import { css } from '@emotion/react';
import { Animation, Colors, Shadows } from '../../../theme';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { ServiceIconConfig } from '../ServiceIcon/constants';
const getPropsWithDefaults = (props) => (Object.assign({ isEmpty: false, hasBorder: true }, props));
const Styles = labelStyles('ServiceIconShell', {
    root: (_props) => {
        const props = getPropsWithDefaults(_props);
        const { borderRadius } = ServiceIconConfig[props.size];
        const border = props.hasBorder ? `1px solid ${Colors.neutral300}` : `none`;
        const background = props.hasWhiteBackground
            ? Colors.white
            : Colors.neutral100;
        return [
            css `
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${background};
        border: ${border};
        border-radius: ${borderRadius}px;
      `,
            withModifier(`size`, css `
          height: ${props.size}px;
          width: ${props.size}px;
        `),
            props.hasShadow &&
                withModifier('shadowed', css `
            box-shadow: ${Shadows.elevation5};
            transition-duration: ${Animation.transitionDuration};
            transition-property: box-shadow;
            transition-timing-function: ${Animation.transitionTimingFunction};
          `),
        ];
    },
});
export const ServiceIconShell = (props) => {
    return (isolateComponent("span", { css: Styles.root(props), "data-testid": "ServiceIconShell" }, props.children));
};
//# sourceMappingURL=ServiceIconShell.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
